import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	summaryChip: {
		borderColor: colors.purple[200],
		color: colors.purple[600],
		backgroundColor: `${colors.purple[100]} !important`,
		fontWeight: 600,
		"&:hover": {
			backgroundColor: colors.purple[200]
		}
	},
	activeChip: {
		backgroundColor: `${colors.purple[600]} !important`,
		color: colors.gray[0],
		borderColor: colors.purple[600],
		"&:hover": {
			backgroundColor: colors.purple[600]
		}
	},
	summaryChipLabel: {
		display: "flex",
		alignItems: "center",
		gap: 4
	},
	summaryChipLabelCompact: {
		padding: 0
	},
	sparklesIcon: {
		fontSize: 14,
		"& path": {
			fill: "currentColor"
		}
	},
	pulsingChip: {
		animation: "$pulseAnimation 1.6s ease-in-out infinite"
	},
	compactChip: {
		borderRadius: theme.spacing(1),
		padding: theme.spacing(0, 0.5)
	},
	deleteIcon: {
		color: colors.purple[500],
		marginLeft: 2,
		"&:hover": {
			color: colors.purple[700]
		}
	},
	"@keyframes pulseAnimation": {
		"0%, 100%": {
			boxShadow: `0 0 0 0 ${colors.purple[300]}`
		},
		"50%": {
			boxShadow: `0 0 0 6px ${colors.purple[100]}`
		}
	}
}))

export default useStyles
